import {EntityData, identifier} from "@fedeltapointofsale/data-client";

export class InventoryBarcodeData extends EntityData<InventoryBarcodeData> {
    @identifier inventoryBarcodeId: number;
}
